import * as Animate from "react-reveal";

const criteria = [
  {
    number: "01",
    title: "Professional experience",
    desc: "Current, credible experience in the subject area you want to teach.",
  },
  {
    number: "02",
    title: "Practical knowledge",
    desc:
      "The ability to connect tools and concepts to real decisions and projects.",
  },
  {
    number: "03",
    title: "Clear communication",
    desc:
      "Confidence explaining complex ideas in language learners can understand.",
  },
  {
    number: "04",
    title: "Mentorship mindset",
    desc:
      "Patience, constructive feedback and a genuine interest in learner progress.",
  },
  {
    number: "05",
    title: "Reliable availability",
    desc:
      "The capacity to prepare, deliver and collaborate consistently with the faculty team.",
  },
];

const TrainerLooksForSection = () => {
  return (
    <section
      className="py-16 md:py-20 lg:py-24 px-4"
      style={{ background: "#fdf2df" }}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                What Utiva looks for
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black mb-5 tracking-[-0.03em] text-primary">
                Strong expertise, explained with care.
              </h2>
              <p className="text-gray text-base font-poppins leading-relaxed">
                Selection considers both subject knowledge and the ability to
                create a clear, supportive learner experience.
              </p>
            </div>
          </Animate.Fade>

          <div className="grid gap-4">
            {criteria.map((item) => (
              <Animate.Fade bottom key={item.number}>
                <div className="flex items-start gap-5 bg-white rounded-2xl p-6">
                  <span className="w-9 h-9 flex-none rounded-full bg-secondary text-primary grid place-items-center font-poppins text-sm font-extrabold">
                    {item.number}
                  </span>
                  <div>
                    <h3 className="font-poppins font-extrabold text-lg text-primary mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </Animate.Fade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainerLooksForSection;
